import { Button, ButtonGroup, Stack, Typography } from '@mui/material';
import { colours } from "../../StyleConstants"
import React, { useState } from "react";
import DUCFAQSection from "./DUCFAQSection";
import DUCDashboard from "./DUCDashboard";
import DucExpiryBanner from "./components/DucExpiryBanner";
import OwnershipTransferBanner from "./components/OwnershipTransferBanner";
import IncomingOwnershipTransferBanner from "./components/IncomingOwnershipTransferBanner";
import LaunchIcon from '@mui/icons-material/Launch';

export const stepLabels = [
    'ACCESS REQUEST',
    'REVIEW BY AUTHORIZED INSTITUTIONAL BUSINESS OFFICIAL',
    'REVIEW BY COMMITTEE',
    'CERTIFICATION'
];

export const stepLabelsDeclinedRecipient = [
    'DECLINED BY RECIPIENT',
    'REVIEW BY AUTHORIZED INSTITUTIONAL BUSINESS OFFICIAL',
    'REVIEW BY COMMITTEE',
    'CERTIFICATION'
];

export const stepLabelsDeclinedOfficial = [
    'ACCESS REQUEST',
    'DECLINED BY AUTHORIZED INSTITUTIONAL BUSINESS OFFICIAL',
    'REVIEW BY COMMITTEE',
    'CERTIFICATION'
];

export const stepLabelsDeclinedCommittee = [
    'ACCESS REQUEST',
    'REVIEW BY AUTHORIZED INSTITUTIONAL BUSINESS OFFICIAL',
    'DECLINED BY COMMITTEE',
    'CERTIFICATION'
];

const DUCpage = () => {
    const [currentSection] = useState('dashboard');

    const renderSections = () => {
        switch (currentSection) {
        case 'dashboard':
            return (<DUCDashboard/>)
        case 'faq':
            return (<DUCFAQSection/>)
        }
    }

    return (
        <Stack
            flexDirection= "column"
            gap={3}
            overflow="auto"
            height="100%">

            <DucExpiryBanner/>
            <OwnershipTransferBanner/>
            <IncomingOwnershipTransferBanner/>

            <Typography
                variant="h1"
                fontWeight="600"
                fontSize="40px"
                textAlign="center"
                color={colours.midnightBlue.blue}>
                Data Use Certification
            </Typography>
            <ButtonGroup
                sx={{ alignSelf: "flex-end", marginBottom: 2 }}
                variant={"outlined"}
                size={"small"}
            >
                <Button
                    role={"link"}
                    endIcon={<LaunchIcon/>}
                    href={"https://www.nbdc-datahub.org/faqs"}
                    target={"_blank"}
                    rel={'noopener noreferrer'}
                    sx={{
                        fontWeight: 'bold',
                        textTransform: "uppercase",
                        borderWidth: "1px",
                        borderRadius: 1,
                    }}
                >
                    FAQ
                </Button>

                <Button
                    role={"link"}
                    endIcon={<LaunchIcon/>}
                    href={"https://www.nbdc-datahub.org/data-access-process"}
                    target={"_blank"}
                    rel={'noopener noreferrer'}
                    sx={{
                        fontWeight: 'bold',
                        textTransform: "uppercase",
                        borderWidth: "1px",
                        borderRadius: 1
                    }}
                >
                    Data Access Process
                </Button>
            </ButtonGroup>
            {renderSections()}
        </Stack>
    )
}

export default DUCpage;